export enum LanguageEnum {
    DA = 'da', 
    DE = 'de', 
    EN = 'en', 
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    KO = 'ko',
    PL = 'pl',
    PT = 'pt',
}